<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props}>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M39.5841 10.8294C41.3042 11.2915 42.665 12.6523 43.1271 14.3724C43.9743 17.5046 44 24.0001 44 24.0001C44 24.0001 44 30.5213 43.1528 33.6279C42.6906 35.348 41.3299 36.7087 39.6098 37.1709C36.5032 38.0181 24 38.0181 24 38.0181C24 38.0181 11.4968 38.0181 8.39025 37.1709C6.67009 36.7087 5.30937 35.348 4.84724 33.6279C4 30.4957 4 24.0001 4 24.0001C4 24.0001 4 17.5046 4.82157 14.3981C5.2837 12.6779 6.64442 11.3172 8.36457 10.8551C11.4711 10.0078 23.9743 9.98218 23.9743 9.98218C23.9743 9.98218 36.4775 9.98218 39.5841 10.8294ZM30.3671 24.0002L19.9949 30.0079V17.9925L30.3671 24.0002Z"
    fill="currentColor"
  />
</svg>
